module.exports = __webpack_public_path__ + "static/media/oldawg_168-150x150.6562dedd.png";